import axios from 'axios';
import config from '../config';
import {
  downloadBlob,
  parseFilenameFromDisposition,
} from '../utils/downloadBlob';

export interface ProductExportFilters {
  search?: string;
  longDescriptionFilter?: boolean;
  noDescriptionFilter?: boolean;
  noCategoryFilter?: boolean;
  noImageFilter?: boolean;
  hasImageFilter?: boolean;
  partialImageFilter?: boolean;
  noBrandInDescFilter?: boolean;
  noStockFilter?: boolean;
  partialStockFilter?: boolean;
  noPriceFilter?: boolean;
  hasStockFilter?: boolean;
  publishDateBefore?: string;
  missingPublishDateFilter?: boolean;
  activeFilter?: string;
  brand?: string;
  brandId?: number;
  categoryId?: number;
}

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : undefined;
};

export async function downloadProductAiExport(
  filters: ProductExportFilters,
): Promise<void> {
  const response = await axios.get(`${config.API_URL}/products/export/ai`, {
    params: filters,
    headers: getAuthHeaders(),
    responseType: 'blob',
  });

  const fallbackName = `ai_product_export_${new Date()
    .toISOString()
    .slice(0, 10)}.xlsx`;
  const filename =
    parseFilenameFromDisposition(response.headers['content-disposition']) ||
    fallbackName;

  downloadBlob(response.data, filename);
}
